<template>
    <div :class="isMobile ? 'panel' : 'well'">
      <div class="info" v-if="!isMobile">
        <b><slot name="title"></slot> </b>
        <small><slot name="time"></slot> </small>
      </div>
      <div class="title" v-if="isMobile">
        <div>
          <slot name="title"></slot>
        </div>
        <div>
          <svg x="0px" y="0px" viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve"> <g> <g> <path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12    c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028    c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265    c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
        </div>
      </div>

      <div class="content" v-if="isMobile">
        <div class="label">
            <span>
                Bahis: <b><slot name="bet"></slot></b>
            </span>
            <span>
                Kazanç: <b><slot name="win"></slot></b>
            </span>
        </div>
        <div class="label">
            <span>
                <slot name="time"></slot>
            </span>
            <span>
                <div class="status-label" :class="'status_' + status_id">{{ status }}</div>
            </span>
        </div>
      </div>

      <div class="detail" v-if="!isMobile">
        <div class="amount">
          <span>Bahis: <strong> <slot name="bet"></slot></strong></span>
          <span>Kazanç: <b> <slot name="win"></slot></b></span>
        </div>
        <div class="status-label" :class="'status_' + status_id">{{ status }}</div>
        <div class="arrow">
            <svg x="0px" y="0px" viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve"> <g> <g> <path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12    c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028    c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265    c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg>
        </div>
      </div>
    </div>
</template>

<script>
  export default{
    props:['status', 'status_id'],
    data(){
      return{

      }
    }
  }
</script>